import React from "react";
import { useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import ShippingRatesFields from "../ShippingRates";
import HoverIconButton from "components/HoverIconButton";
import { SHIPPING_OPTION_COPY } from "utils/constants/shippingRate";
import { useMessagesError } from "utils/hooks/editor";
import { STATE_KEYS } from "utils/constants/state";
import classnames from "classnames";

const ShippingOptionsSelect = ({ name, hasOptions }) => {
  const { setFieldValue } = useFormikContext();
  const shippingOptionsPath = getFieldPath(name, "shipping_options");
  const error = useMessagesError(STATE_KEYS.SHORT_LINK.SHIPPING_OPTIONS);

  return (
    <div className="flex flex-column justify-between items-start pv3 mt3 bt hairline-1">
      <div className="flex flex-row justify-between items-center w-100 pb1">
        <label
          className={classnames("f5 fw6 db", {
            "color-error": error
          })}
        >
          Rate options
        </label>
        {hasOptions && (
          <HoverIconButton
            type="refresh"
            tooltip="Reset"
            onClick={() => {
              setFieldValue(shippingOptionsPath, []);
            }}
          />
        )}
      </div>
      <label
        className={classnames("field__label db f6 lh-copy pt2", {
          pb3: hasOptions,
          pb2: !hasOptions
        })}
      >
        {SHIPPING_OPTION_COPY.INFO}
      </label>
      <ShippingRatesFields showEmptyCopy={false} />
    </div>
  );
};

export default ShippingOptionsSelect;
